export default __webpack_public_path__ + "static/media/pending.9d0fda25.svg";